// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const RoleAnalysisStatusSchema = z.enum(['PENDING','ANALYZING','COMPLETED','FAILED'] as const);

export type RoleAnalysisStatusType = `${z.infer<typeof RoleAnalysisStatusSchema>}`

export default RoleAnalysisStatusSchema;
